/* eslint-disable no-unused-vars */
import React, { useRef } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, makeStyles,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import PrimaryButton from './PrimaryButton';

const useStyles = makeStyles((theme) => ({
  customAlert: {
    padding: 20,
  },
}));

export default function ComplexAlert({
  open, setOpen, header, body, callback,
}) {
  const classes = useStyles();

  const dialogRef = useRef(null);

  const handleClose = () => {
    setOpen(false);
    if (callback) callback();
  };

  return (
    <Dialog
      ref={dialogRef}
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" className={classes.customAlert}>{header || 'Alert'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {body.map((string) => (
            <div key={string}>
              {string}
              <br />
            </div>
          ))}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.customAlert}>
        <PrimaryButton onClick={handleClose} color="primary" autoFocus>
          Close
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}
ComplexAlert.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  body: PropTypes.arrayOf(PropTypes.string).isRequired,
  callback: PropTypes.func,
};
ComplexAlert.defaultProps = {
  callback: () => { },
};
